import React from "react";
import classNames from "classnames";
import "./style.css";
export default function DNALoader(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("dna-loader", className),
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: "nucleobase"
  }), /*#__PURE__*/React.createElement("div", {
    className: "nucleobase"
  }), /*#__PURE__*/React.createElement("div", {
    className: "nucleobase"
  }), /*#__PURE__*/React.createElement("div", {
    className: "nucleobase"
  }), /*#__PURE__*/React.createElement("div", {
    className: "nucleobase"
  }), /*#__PURE__*/React.createElement("div", {
    className: "nucleobase"
  }), /*#__PURE__*/React.createElement("div", {
    className: "nucleobase"
  }), /*#__PURE__*/React.createElement("div", {
    className: "nucleobase"
  }), /*#__PURE__*/React.createElement("div", {
    className: "nucleobase"
  }), /*#__PURE__*/React.createElement("div", {
    className: "nucleobase"
  }));
}